import { render, staticRenderFns } from "./MobileLoaders.vue?vue&type=template&id=4fe4c756&"
import script from "./MobileLoaders.vue?vue&type=script&lang=js&"
export * from "./MobileLoaders.vue?vue&type=script&lang=js&"
import style0 from "./MobileLoaders.vue?vue&type=style&index=0&id=4fe4c756&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports